module.exports = __webpack_public_path__ + "img/withdrawal.ac6533a6.png";